import { inject, NgModule } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from './google-tag-manager.service';
import { appSettings } from '@nha/config';
import { IUser, UserSessionService } from '@nha/auth';

@NgModule({
	imports: [],
	declarations: [],
	exports: [],
	providers: []
})
export class NHATagManagerModule {
	private router = inject(Router);
	private userSessionService = inject(UserSessionService);
	private gtmService = inject(GoogleTagManagerService);
	private activeRoute: ActivatedRoute = inject(ActivatedRoute);

	constructor() {
		if (appSettings.analytics?.isEnabled) {
			this.gtmService.initialize(appSettings.analytics.code);

			this.router.events.subscribe((item) => {
				if (item instanceof NavigationEnd) {
					const pageTitleParts: string[] = [];

					let child = this.activeRoute.firstChild;
					while (child) {
						if (child.snapshot?.routeConfig?.title) {
							pageTitleParts.push(child.snapshot.routeConfig.title.toString());
						}

						child = child.firstChild;
					}

					const activePageTitle = `${pageTitleParts[pageTitleParts.length - 1]}`;

					const gtmTag = {
						event: 'spa.page_view',
						page_title: activePageTitle,
						page_location: location.href,
						page_path: item.urlAfterRedirects
					};

					this.gtmService.pushTag(gtmTag);
				}
			});

			const user: IUser = this.userSessionService.getUser();
			this.gtmService.pushTag({
				user_id: user.userGuid
			});
			this.gtmService.pushTag({
				display_name: user.fullName
			});
			this.gtmService.pushTag({
				email: user.email
			});
			this.gtmService.pushTag({
				staff_id_int: user.staffID
			});
			this.gtmService.pushTag({
				job_title: user.jobTitle
			});
			this.gtmService.pushTag({
				is_service_center: user.isServiceCenter
			});
			this.gtmService.pushTag({
				location_id: user.locationID
			});
			this.gtmService.pushTag({
				school_id_str: user.schoolIDs.join(',')
			});
			this.gtmService.pushTag({
				state_id_str: user.stateIDs.join(',')
			});
		}
	}
}
